import React from 'react';

import {Link, useParams} from 'react-router-dom';
import {gql, useQuery} from "@apollo/client";
import {Skeleton} from "antd";
import map from 'lodash/map';

import CrmLayout from "../../../components/CrmLayout";
import CrmCenteredTitle from "../../../components/CrmCenteredTitle";
import CrmAvatar from "../../../components/CrmAvatar";
import {client_info, subscription_info} from "../../../routes";
import {CheckCircleOutlined, CloseCircleOutlined} from "@ant-design/icons";

const REPORT_GYM = gql`
    query reportGym ($endDate: String!, $id: String!, $startDate: String!) {
        reportGym (startDate: $startDate, endDate: $endDate, id: $id) {
            totalMoney {
                count
                sumPaid
                sumExpected
                data {
                    id
                    attributes {
                        createdAt
                        amount
                        paid
                        subscription {
                            data {
                                id
                                attributes {
                                    user {
                                        data {
                                            id
                                            attributes {
                                                role {
                                                    data {
                                                        id
                                                        attributes {
                                                            name
                                                        }
                                                    }
                                                }
                                                client {
                                                    data {
                                                        id
                                                        attributes {
                                                            firstName
                                                            lastName
                                                            color
                                                            avatar {
                                                                data {
                                                                    attributes {
                                                                        url
                                                                        previewUrl
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                parent {
                                                    data {
                                                        id
                                                        attributes {
                                                            firstName
                                                            lastName
                                                            color
                                                            avatar {
                                                                data {
                                                                    attributes {
                                                                        url
                                                                        previewUrl
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default function ReportGymTotalMoney() {

    const {id, startDate, endDate} = useParams();

    // console.log('startDate', startDate);
    // console.log('endDate', endDate);

    const reportGym = useQuery(REPORT_GYM, {
        variables: {
            startDate: startDate,
            endDate: endDate,
            id: id
        }
    });

    return (
        <CrmLayout>
            <CrmCenteredTitle title={'Поступления'}/>
            {reportGym.loading
                ?
                <Skeleton active/>
                :
                <>
                    {/*<p className={'caption color-gray-3'}>Клиенты, у которых есть минимум 1 абонемент в этом зале и выбранном периоде</p>*/}

                    <div className={'bold'}>Сумма поступлений: {reportGym.data.reportGym.totalMoney.sumPaid} ₽</div>
                    {/*<div className={'caption'}>Ожидаемая сумма: {reportGym.data.reportGym.totalMoney.sumExpected} ₽</div>*/}

                    <div className={'crm-report-line caption'}>
                        Клиент
                        <div className={'crm-report-count'}>
                                Оплаты
                        </div>
                    </div>

                    {map(reportGym.data.reportGym.totalMoney.data, (value, index) => {

                        const subscription = value.attributes.subscription.data;
                        const user = subscription.attributes.user.data;
                        const roleName = user.attributes.role.data.attributes.name;

                        let person = null;
                        let child = false;

                        if (roleName === 'Child') {
                            person = user.attributes.client.data;
                            child = true;
                        }

                        if (roleName === 'Parent') {
                            person = user.attributes.parent.data;
                        }


                        const firstName = person.attributes.firstName;
                        const lastName = person.attributes.lastName;
                        const avatar = person.attributes.avatar.data;

                        let avatarUrl = null;

                        if (avatar) {
                            avatarUrl = avatar.attributes.previewUrl;
                        }

                        const color = person.attributes.color;

                        const subscriptionId = subscription.id;
                        const amount = value.attributes.amount;
                        const paid = value.attributes.paid;

                        return (
                            <div className={'crm-report-line'} key={index}>
                                <Link to={client_info(user.id)}>
                                    <CrmAvatar
                                        avatarUrl={avatarUrl}
                                        firstName={firstName}
                                        lastName={lastName}
                                        child={child}
                                        color={color}
                                    />
                                </Link>


                                <div className={'crm-report-count'}>
                                    <Link to={subscription_info(subscriptionId)}>
                                        № {subscriptionId}
                                    </Link>
                                </div>

                                <div className={'crm-report-price'}>{amount} {amount && '₽'}</div>

                                {paid === true
                                    ?
                                    <CheckCircleOutlined className={'color-success'}/>
                                    :
                                    <CloseCircleOutlined className={'color-danger'}/>
                                }

                            </div>
                        )
                    })}
                </>
            }
        </CrmLayout>
    );
}



